import React from 'react'
import { Switch, Route } from 'react-router-dom'

import Loadable from 'src/utils/loadable'

const routes = () => {
  return (
    <Switch>
      <Route path='/claims/review' component={Loadable(() => import('./Review'))} />
      <Route path='/claims/notes' component={Loadable(() => import('./Notes'))} />
      <Route path='/claims/witness' component={Loadable(() => import('./Witness'))} />
      <Route path='/claims/passenger' component={Loadable(() => import('./Passenger'))} />
      <Route
        path='/claims/other-vehicle-and-driver'
        component={Loadable(() => import('./OtherVehicleAndDriver'))}
      />
      <Route
        path='/claims/investigating-officer'
        component={Loadable(() => import('./InvestigatingOfficer'))}
      />
      <Route path='/claims/what-happened' component={Loadable(() => import('./WhatHappened'))} />
      <Route path='/claims/time-and-date' component={Loadable(() => import('./TimeAndDate'))} />
      <Route path='/claims/pictures' component={Loadable(() => import('./Pictures'))} />
      <Route path='/claims/drivers' component={Loadable(() => import('./Drivers'))} />
      <Route path='/claims/weather' component={Loadable(() => import('./Weather'))} />
      <Route path='/claims/location' component={Loadable(() => import('./Location'))} />
      <Route path='/claims/vehicles' component={Loadable(() => import('./Vehicles'))} />
      <Route
        path='/claims/form/:navType?'
        component={Loadable(() => import('./Claims.container'))}
      />
      <Route path='/claims/phones' component={Loadable(() => import('./PhoneNumbers'))} />
      <Route path='/claims' component={Loadable(() => import('./ClaimType'))} />
    </Switch>
  )
}

export default routes
